import { render, staticRenderFns } from "./BrandContentList.vue?vue&type=template&id=5f7c448b&scoped=true&"
import script from "./BrandContentList.vue?vue&type=script&lang=js&"
export * from "./BrandContentList.vue?vue&type=script&lang=js&"
import style0 from "./BrandContentList.vue?vue&type=style&index=0&id=5f7c448b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c448b",
  null
  
)

export default component.exports